import React, { useState, forwardRef } from "react";
import { EyeOutline, EyeOffOutline } from "heroicons-react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  showPasswordToggle?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      error,
      showPasswordToggle = false,
      type = "text",
      className = "",
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const inputType = showPasswordToggle && showPassword ? "text" : type;
    const isPasswordType = type === "password";

    return (
      <div className="w-full">
        <label
          htmlFor={props.id || props.name}
          className="block pb-2 text-[#263238] font-[18px] font-gilroy-medium"
        >
          {label}
        </label>

        <div className="relative w-full">
          <input
            ref={ref}
            type={inputType}
            className={`border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4 ${isPasswordType ? "pr-12" : ""
              } ${className}`}
            {...props}
          />

          {showPasswordToggle && isPasswordType && (
            <button
              type="button"
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute bottom-4 right-4 cursor-pointer"
            >
              {showPassword ? (
                <EyeOffOutline color="#AAB7C2" />
              ) : (
                <EyeOutline color="#AAB7C2" />
              )}
            </button>
          )}
        </div>

        {error && (
          <p className="text-red-500 text-sm">
            {error}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
